import EditIncidentTypes from "../../../Types/EditIncidentTypes"

let incidentParams: EditIncidentTypes | any =
{
    Supervisors: [],
    MedicalAppointments: [],
    Checklist: [],
    StateName: null,
    IncidentTypeDesc: null,
    IncidentStatusDesc: null,
    WorkersCompensationIncidentId: null,
    EmployeeId: null,
    IncidentTypeId: null,
    IncidentDateUTC: null,
    IncidentStateId: null,
    IncidentStatusId: null,
    ClaimNumber: null,
    FullDutyReleaseDateUTC: null,
    DaysOffWork: null,
    DaysLightDuty: null,
    IncidentDescription: null,
    Restrictions: null,
    RestrictionsDescription: null,
    MedicalTreatment: null,
    OshaRecordable: null,
    CreatedDateUTC: null,
    CreatedBy: null,
    ModifyDateUTC: null,
    ModifiedBy: null,
    DeletedDateUTC: null,
    DeletedBy: null,
    DisabledDateUTC: null,
    DisabledBy: null,
}
export default incidentParams


